export const getRefresh = state => state.user.refresh;

export default {
	getRefresh,
};
